import * as standaloneThemes from './standalone'
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles'
import theme from './theme'

export function createArtistTheme(artistName: string) {
  const artistTheme = standaloneThemes[artistName] || {}

  return responsiveFontSizes(createMuiTheme(artistTheme))
}

export function createDefaultTheme() {
  return responsiveFontSizes(createMuiTheme(theme))
}

export function createTheme(artistName: string = null) {
  if (!artistName) return createDefaultTheme()

  return createArtistTheme(artistName)
}
